import axios from 'axios';
import { logger } from '@/common/logger';

/**
 * Holt beim Upload‑Service eine presign‑URL und lädt die Datei hoch
 * @param {File} file  – Browser File‑Objekt
 * @returns {Promise<{key:string, fullPath:string, status:number}>}
 */
export async function singleUpload(file) {
  try {
    // 1) presign‑URL anfordern
    const presignRes = await axios.get(
      `${process.env.VUE_APP_UPLOAD_API}/upload/presign`,
      {
        params: {
          filename: file.name,
          type: file.type,
        },
      },
    );

    const { url, key } = presignRes.data;

    // 2) PUT‑Upload direkt zum S3‑Bucket
    const putRes = await axios.put(url, file, {
      headers: { 'Content-Type': file.type },
    });

    const bucketUrl = url.split(key)[0]; // Basis‑URL vor dem Key
    return {
      key,
      fullPath: `${bucketUrl}${key}`,
      status: putRes.status,
    };
  } catch (err) {
    logger.error('Upload‑Fehler', err);
    throw err;
  }
}

/**
 * Löscht ein Objekt über den Upload‑Service
 */
export async function deleteObjectByKey(key) {
  return axios.delete(
    `${process.env.VUE_APP_UPLOAD_API}/upload/object`,
    { params: { key } },
  );
}
